<template>
<div class="connectcode" v-if="false">

    <div class="iconpart" @mouseenter="dingdingflag=true" @mouseleave="dingdingflag=false" :class="{'actived':dingdingflag}">
        <i class="iconfont icon-pinpaibiaoshi-dingding" ></i>
        <transition name="el-fade-in-linear">
            <div class="qrcode" v-if="dingdingflag">
                <img src="../assets/image/connectcode/dingding.png">
                <p class="mt-5">钉钉扫码入群</p>
                <p>大泽让抠图更简单</p>
            </div>
        </transition>
    </div>
    <div class="iconpart bt-n" @mouseenter="wxflag=true" @mouseleave="wxflag=false" :class="{'actived':wxflag}">
        <i class="iconfont icon-weixin"></i>
        <transition name="el-fade-in-linear">
            <div class="qrcode" v-if="wxflag">
                <img src="../assets/image/connectcode/wx.png">
                <p class="mt-5">微信扫码，备注抠图</p>
                <p>大泽让抠图更简单</p>
            </div>
        </transition>
    </div>

</div>
</template>

<script>
export default {
    data() {
        return {
            dingdingflag: false,
            wxflag: false
        };
    },
    mounted() {}
};
</script>

<style lang="scss" scoped>
.connectcode {
    position: fixed;
    left: 30px;
    bottom: 19px;
    z-index: 999;
    cursor: pointer;

    .iconpart {
        width: 60px;
        height: 60px;
        border: 1px solid rgb(228, 228, 228);
        background: #fff;
        text-align: center;
        box-sizing: border-box;
        padding-top: 10px;

        i {
            font-size: 40px;
            color: rgb(78, 78, 78);
            line-height: 1;
        }
    }

    .bt-n {
        border-top: none;
    }

    .qrcode {

        border: 1px solid rgb(228, 228, 228);
        text-align: center;
        position: absolute;
        width: 180px;
        height: 220px;
        left: 59px;
        bottom: 0px;
        background: #fff;

        img {
            width: 130px;
            padding-top: 25px;
        }

        p {
            font-size: 14px;
            line-height: 22px;
            margin: 0
        }

        .mt-5 {
            margin-top: 5px
        }
    }

    .actived {
        i {
            color: #fff !important
        }

        background: #0763fc;
    }
}
</style>
